import type { ResourceArticle } from '~/types/ResourceArticle'

export const understandingBipolarArticle: ResourceArticle = {
  uid: 'understanding-bipolar',
  thumbnailImageUrl: 'https://cdn.hubofhope.co.uk/public/img/thumbs/RESOURCES_BIPOLAR_800x800.jpg',
  thumbnailImageAlt: 'Bipolar',
  title: 'Understanding bipolar',
  supportNeedCategoryUid: 'epnBTE7G7v5GtcR6SvbE',
  supportNeedCategoryLabel: 'Bipolar',
  isFeatured: true,
  excerpt:
    'We all experience different moods, and for some of us, these variations can be more extreme at times.',
  content: `
  <div class="prose mt-4">
    <p class="font-bold">
      We all experience different moods, and for some of us, these variations can be more extreme at times.
    </p>
  
    <h2 class="mt-6 font-semibold text-lg font-brown text-primary">Alternation in mood</h2>
    <p>
      We may experience periods of depression and feel like we are a complete failure 
      (<a href="/resource/understanding-depression" class="text-blue-500 underline hover:text-blue-700">see Understanding depression</a>). 
      We may also experience periods where we feel elated, 'high' and full of energy, but also often agitated and restless, 
      and we find it hard to sleep. This is sometimes called 'mania'. During periods of elation, we may sometimes develop beliefs 
      that other people don't share or find strange, or hear voices when there is no-one there 
      (<a href="/resource/psychosis-hearing-voices" class="text-blue-500 underline hover:text-blue-700">see Psychosis & hearing voices</a>). 
      Some of these experiences may be linked to past trauma 
      (<a href="/resource/trauma-post-traumatic-stress" class="text-blue-500 underline hover:text-blue-700">see Trauma & post-traumatic stress</a>).
    </p>
  
    <p class="italic mt-4">
      “This alternation between depression and elation is sometimes called 'bipolar'.”
    </p>
  
    <figure class="my-8">
      <img src="https://cdn.hubofhope.co.uk/public/img/thumbs/matthew-brindle-KBUqsvMIhLc-unsplash_800x800.jpg"
           alt="Understanding bipolar article image" 
           class="max-w-md w-full h-auto rounded shadow-md mx-auto">
    </figure>
  
    <h2 class="mt-6 font-semibold text-lg font-brown text-primary">Seeking help</h2>
    <p class="mb-8">
      In terms of help, different things help different people. Often practical things such as self-care are central, including 
      exercise, eating, and sleeping well. If you are feeling 'high,' it can often be useful to make ourselves stay in bed for 
      a day to regain our equilibrium. Doing things that connect us with others, including people with similar experiences, 
      either informally or in organized peer support groups can be a big support. Therapy or counseling can enable us to 
      understand what might have led to our feelings of depression or elation, and our changes in mood, and can help us find 
      ways to support ourselves and to regulate our physical and emotional states. Some people find medication helpful.
    </p>
  </div>`
}
